export const footerContent = {
  tagline: 'AI & data for Retail and CPG.',
  copyright: '© 2024 Orca Labs. All rights reserved.',
};
